<template>
  <el-row class="ta-header">
    <div class="ta-chart-header ta-chart-header__with-hint">
      {{$t('charts.rangeHours.title')}}
    </div>
    <div id="rangesHistogram"/>
  </el-row>
</template>

<script>
import Highcharts from 'highcharts'

export default {
  name: 'RangeHours',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  watch: {
    data () {
      if (this.data.hours) {
        this.rerender()
      }
    }
  },
  methods: {
    getLabels () {
      const labels = []
      for (const zone of this.data.hours.zones) {
        for (const range of zone.ranges) {
          labels.push(this.$t('hours.' + range.label))
        }
      }
      return labels
    },
    getValues () {
      const values = []
      for (const zone of this.data.hours.zones) {
        for (const range of zone.ranges) {
          values.push(range.value / 1000)
        }
      }
      return values
    },
    rerender () {
      Highcharts.chart('rangesHistogram', {
        chart: {
          type: 'column',
          backgroundColor: '#F1F6E4'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.getLabels(),
          title: {
            enabled: true,
            text: this.$t('charts.rangeHours.xAxis')
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        yAxis: {
          title: {
            text: this.$t('charts.rangeHours.yAxis')
          }
        },
        series: [{
          name: '',
          data: this.getValues()
        }]
      })
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
